import { Pipe, PipeTransform } from '@angular/core';
import { Product } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'productSizes',
})
export class ProductImageSetPipe implements PipeTransform {
  private imageEndpoint = `${environment.cmsOrigin}`;

  transform(product: Product, big = false): string {
    if (product?.primaryImageUrl) {
      const storeImageUrl = `${this.imageEndpoint}${product?.primaryImageUrl}?width=360&mode=max&autorotate=true`;
      // storeImageUrl += big ? `?width=266&mode=max` : '?width=300&mode=max';

      const small = `${storeImageUrl}&quality=60`;
      const standard = `${storeImageUrl}&quality=80`;
      const large = `${storeImageUrl}`;

      return `${small} 0.5x, ${standard} 0.75x, ${large}`;
    }

    return 'assets/placeholder.png';
  }
}
